import React, { useEffect, useState } from "react";
import { Route, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import authService from "./AuthorizeService";
import { CircularLoader } from "../atoms/Loaders";
import { useCurrentJourneys } from "../hooks/useCurrentJourneys";

interface Props {
  component: React.ComponentType;
  rest: any;
  programmeId: string | null;
  path: string;
}

export const OtpRoute: React.FC<Props> = (props: Props) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  const otpState = useSelector((state: any) => state.otp);
  const history = useHistory();
  const [currentJourneys, currentJourneysReady] = useCurrentJourneys();

  useEffect(() => {
    const fetchUser = async () => {
      const user = await authService.getUser();
      setIsAuthenticated(!!user && !!user.sub);
    };

    fetchUser();
  }, []);

  useEffect(() => {
    //If an existing user has any current journeys for the requested programme, prevent access to the
    // eligibility checker urls and the select programme url so that they are unable to start a new referral.
    if (isAuthenticated) {
      if (
        (props.programmeId != null && userHasCurrentJourneyForProgramme()) ||
        props.path === "/select-programme"
      ) {
        history.push("/");
      }
    }

    function userHasCurrentJourneyForProgramme() {
      return (
        currentJourneysReady &&
        Array.isArray(currentJourneys) &&
        currentJourneys.find(j => j.programmeId === props.programmeId)
      );
    }
  }, [currentJourneysReady, currentJourneys, history, props.programmeId, isAuthenticated, props.path]);

  if (isAuthenticated == null || (isAuthenticated && !currentJourneysReady)) {
    return <CircularLoader />;
  }

  if (!otpState.isVerified && !isAuthenticated) {
    history.push("/sign-up");
  }

  const { component: Component, ...rest } = props;
  return (
    <Route
      {...rest}
      render={renderProps => {
        return <Component {...renderProps} />;
      }}
    />
  );
};
